import { useMemo, useState } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import moment from "moment";
import { Button, Icon } from "abs-ui-components";
import "./Corrections.scss";
import CorrectionRequestForm from "./CorrectionRequestForm";
import AbsModal from "../../../common/absModal/AbsModal";

const PlanVerificationCorrectionsChildTable = ({ parentCorrectionData, planDetails, fetchData }) => {

	const [rowSelection, setRowSelection] = useState({});
	const [selectAll, setSelectAll] = useState(false);

	const correctionListSubColumns = useMemo(
		() => [
			{
				accessorKey: "planMessage",
				header: "Message",
			},
			{
				accessorKey: "createdBy",
				header: "Created By",
			},
			{
				accessorKey: "createdOn",
				header: "Created",
				accessorFn: (row) => {
					if (row.createdOn) {
						return moment(row.createdDate).format("DD-MMM-YYYY HH:mm:ss"); //row.createdDate is in Utc from BE
					}
				},
			},
		],
		[]
	);

	const [isCorrectionMsgModalOpen, setIsCorrectionMsgModalOpen] =
		useState(false);

	const toggleCorrectionMessage = () => {
		setIsCorrectionMsgModalOpen(!isCorrectionMsgModalOpen);
	};

	const handleSelectAll = (event) => {
		setSelectAll(event.target.checked);
	};

	const childTable = useMaterialReactTable({
		columns: correctionListSubColumns,
		data: parentCorrectionData?.messages || [],
		enableRowSelection: true,
		enableStickyHeader: true,
		enableBottomToolbar: false,
		enableTopToolbar: true,
		enablePagination: false,
		manualFiltering: true,
		manualSorting: true,
		filterFromLeafRows: true,
		onRowSelectionChange: setRowSelection,
		getRowId: (row) => row.planCorrectionMsgId,
		state: { rowSelection },
		initialState: {
			density: "compact",
			columnOrder: ["Message", "CreatedBy", "Created"],
		},

		muiTableBodyRowProps: () => ({
			sx: {
				cursor: "pointer",
			},
		}),

		muiTableContainerProps: {
			sx: {
				maxHeight: "calc(100vh - 379px)",
				padding: 0,
				margin: 0,
			},
		},
		muiTableBodyCellProps: {
			sx: {
				paddingTop: 0,
				marginTop: 0,
				marginBottom: 0,
				paddingBottom: 0,
			},
		},
		renderToolbarInternalActions: ({ table }) => <></>,
		muiTableHeadCellProps: ({ column }) => ({
			id: `${column.columnDef.accessorKey}`,
			sx: {
				color: "rgb(255 255 255)",
				"& .MuiButtonBase-root": {
					color: "white !important",
					"& .MuiTableSortLabel-icon": {
						color: "white !important",
					},
				},
			},
		}),
		muiFilterTextFieldProps: {
			sx: {
				"& .MuiInput-root": {
					color: "white !important",
				},
				"& .MuiButtonBase-root": {
					color: "white !important",
				},
				"& .MuiInputBase-root::after": {
					transform: "none",
					borderBottom: "2px solid white",
				},
			},
		},
		muiColumnActionsButtonProps: {
			sx: {
				color: "white",
			},
		},
		muiSelectAllCheckboxProps: {
			title: selectAll ? "Toggle deselect all" : "Toggle select all",
			onClick: (e) => handleSelectAll(e),
			disabled: parentCorrectionData?.messages?.length === 0,
			sx: {
				color: "white",
			},
		},
		muiTableHeadRowProps: {
			sx: {
				backgroundColor: "#042a4c !important",

				"& .MuiTableCell-head::before": {
					backgroundColor: "#042a4c !important",
				},
			},
		},
		muiTablePaperProps: {
			sx: {
				boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)",
			},
		},
		renderTopToolbarCustomActions: ({ table }) => (
			<>
				<div className="container-fluid">
					<div className="row p-0 m-0 d-flex align-items-center mt-2">
						<Button
							startIcon={<Icon icon="add" />}
							variant="secondary"
							className="ml-2"
							onClick={toggleCorrectionMessage}
						>
							REPLY
						</Button>
					</div>
				</div>
			</>
		),
	});

	return (
		<>
			&nbsp;
			<MaterialReactTable table={childTable} />
			&nbsp;
			<div className="corrections-request-form-child">
				{isCorrectionMsgModalOpen && (
					<AbsModal
						isOpen={isCorrectionMsgModalOpen}
						title="Correction Request"
						onClose={setIsCorrectionMsgModalOpen}
						close={toggleCorrectionMessage}
					>
						<CorrectionRequestForm
							toggleCorrection={toggleCorrectionMessage}
							planDetails={planDetails}
							isRepliedCorrection={true}
							parentCorrectionData={parentCorrectionData}
							fetchData={fetchData}
						/>
					</AbsModal>
				)}
			</div>
		</>
	);
};

export default PlanVerificationCorrectionsChildTable;
